import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsOpenbadgesComponent } from './simple-icons-openbadges.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsOpenbadgesComponent ],
    exports:      [ SimpleIconsOpenbadgesComponent ],
    bootstrap:    []
})
export class SimpleIconsOpenbadgesModule {}
